/**
 * ReferenceMaterialsPanel - Display uploaded files and reference materials
 */

import React from 'react';
import type { UploadedFile } from '../../types/navigation';

interface ReferenceMaterialsPanelProps {
  uploadedFiles: UploadedFile[];
  className?: string;
}

const ReferenceMaterialsPanel: React.FC<ReferenceMaterialsPanelProps> = ({
  uploadedFiles,
  className = '',
}) => {
  if (uploadedFiles.length === 0) {
    return null;
  }

  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        参照した資料
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {uploadedFiles.map((uploadedFile, index) => (
          <div 
            key={index} 
            className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <svg 
              className="w-5 h-5 text-gray-400 mr-3 flex-shrink-0" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
              />
            </svg>
            <span 
              className="text-sm text-gray-700 truncate"
              title={uploadedFile.file.name}
            >
              {uploadedFile.file.name}
            </span>
          </div>
        ))}
      </div>
      
      {uploadedFiles.length > 4 && (
        <p className="text-sm text-gray-500 mt-3">
          他 {uploadedFiles.length - 4} 件のファイル
        </p>
      )}
    </div>
  );
};

export default ReferenceMaterialsPanel;